import { TrackInfo } from './../../model/track-info';
import { trackDefaultIncomeBasic } from './../util/track-default-income';
import { TrackActionResult } from "../../model/track-action-result";
import { RegistratioData } from "src/app/shared/model/registration-data";

export class OriginInvestAction {

    public static execute(data: RegistratioData, track: TrackInfo[],
                          edit?: boolean, includeTrack?: (track: TrackInfo[]) => void): TrackActionResult {
        const id = data.professionalData.originIncome;
        const income: string = data.incomeEquity?.income;
        const patrimony: string = data.incomeEquity?.patrimony;

        const idNotProf = ['11839', '11843', '11838', '11841', '11834', '11837', '12230', '11840'];
        const idNotIncome = ['12230', '11841', '11834'];
        const idNotPatrimony = ['11837', '11840'];

        const filterIdNotProf = idNotProf.find(x => x === id);
        const filterIdNotIncome = idNotIncome.find(x => x === id);
        const filterIdNotPatrimony = idNotPatrimony.find(x => x === id);
        const hasStepIncome = track.findIndex((page: TrackInfo) => page.pageId === 'income-wealthincome') > -1;

        if (!filterIdNotIncome && !income
            || !filterIdNotIncome && income === '0.00'
            || !filterIdNotIncome && income === ''
            || filterIdNotPatrimony && patrimony === '0.00'
            || filterIdNotPatrimony && patrimony === ''
        ) {
            if (!hasStepIncome && includeTrack) {
                includeTrack(trackDefaultIncomeBasic);
            }
        }

        if (id === '12229') {
            const trackInfo = new TrackInfo('company-cnpj', ['professional-data', 'company-cnpj']);
            return new TrackActionResult(data, trackInfo);
        }

        if (filterIdNotProf !== undefined) {
            if (filterIdNotIncome && !edit && hasStepIncome
                || !filterIdNotIncome && !income
                || !filterIdNotIncome && income === '0.00'
                || !filterIdNotIncome && income === ''
                || filterIdNotPatrimony && patrimony === '0.00'
                || filterIdNotPatrimony && patrimony === ''
            ) {
                const trackInfo = new TrackInfo('income-wealthincome', ['income', 'income-wealthincome']);
                return new TrackActionResult(data, trackInfo);
            } else {
                return new TrackActionResult(data, undefined);
            }
        } else {
            const trackInfo = new TrackInfo('profession', ['professional-data', 'profession']);
            return new TrackActionResult(data, trackInfo);
        }
    }

}